module.exports = __webpack_public_path__ + "static/media/supervise-empty.7434c6c5.png";